import React, {Component} from 'react';
import { connect } from 'react-redux';

import '../../sass/headers/header.scss';

import {t, dt} from 'l10n';

import paths from 'paths';

class HeaderWalletCharge extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {
        let {replenish, currentUser, virtualGifts} = this.props;

        return (
            <header className="headerWallet">
                <div className="content">
                    <h1>{t('My wallet')}</h1>
                    <div className="text-headerWallet">
                        <div className="info-wallet">
                            <div className="points">
                                {t('%1 tokens', currentUser.counters.amount_wallet)}
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}

export default connect(
    state => ({
        currentUser: state.currentUser,
        history: state.memberWallet.history,
        virtualGifts: state.memberWallet.virtualGifts,
    }),({

    })
)(HeaderWalletCharge)




// WEBPACK FOOTER //
// ./src/components/walletcharge/HeaderWalletCharge.js